module.exports = __webpack_public_path__ + "13aff2a26efc4f037f9b849973d5a39f.svg";